module.exports = __webpack_public_path__ + "img/logo_b_s.3b0b1c64.png";